import { CompactContentCardConfig } from "@ui/context/component-config-context";

const compactContentCardConfig: CompactContentCardConfig = {
  contentBlockSize: "medium",
  contentBlockVariation: "standard",
  coverLink: true,
  imagePosition: "floatRight",
  imageAspectRatio: "squareMobile",
  lowerMetaFirstComponent: "ContentBlockByline",
  lowerMetaSecondComponent: "CommentCount",
  lowerMetaThirdComponent: null,
  mediaVariationIconPlacement: "thumbnail",
  showCommentCallout: false,
  showDek: true,
  showScore: false,
  upperMetaSecondComponent: "Timestamp",
  upperMetaThirdComponent: null,
  latestRecircPadding: false,
  alignTop: false,
  componentContext: {
    river: {
      mediaIconInset: "smallMobile",
    },
    articleParentRecircStream: {
      imagePosition: "left",
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
    },
    articleParentRecircPackage: {
      imagePosition: "left",
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
    },
    specialEvent: {
      contentBlockSize: "micro",
      imagePosition: "left",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
    },
    latestRecirc: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "hideImage",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      mediaVariationIconPlacement: "title",
      showDek: false,
      upperMetaFirstComponent: "Timestamp",
      upperMetaSecondComponent: null,
    },
    nGridPatternMobile: {
      contentBlockSize: "micro",
      imagePosition: "right",
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
    },
    recommendedRecirc: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "hideImage",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      mediaVariationIconPlacement: "title",
      showDek: false,
      upperMetaFirstComponent: "Timestamp",
      upperMetaSecondComponent: null,
    },
    threeUpPattern: {
      imagePosition: "floatRight",
      lowerMetaSecondComponent: null,
      upperMetaSecondComponent: null,
    },
    threeUpAltTwoPatternSecondaryMobile: {
      imagePosition: "left",
      lowerMetaSecondComponent: "CommentCount",
      contentBlockSize: "medium",
      contentBlockVariation: "standard",
      showDek: false,
    },
    fourUpPattern: {
      upperMetaSecondComponent: null,
    },
    fourUpAltPattern: {
      upperMetaSecondComponent: null,
      lowerMetaSecondComponent: null,
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "left",
      showDek: false,
    },
    fourUpAltPatternTablet: {
      upperMetaSecondComponent: null,
      lowerMetaSecondComponent: null,
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "left",
      showDek: false,
    },
    fourUpAltPrimaryRightPattern: {
      upperMetaSecondComponent: null,
      lowerMetaSecondComponent: null,
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "right",
      showDek: false,
    },
    sixUpPatternTop: {
      imagePosition: "right",
      lowerMetaFirstComponent: null,
      showDek: false,
      upperMetaSecondComponent: null,
    },
    sixUpPatternBottom: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "hideImage",
      lowerMetaFirstComponent: null,
      mediaVariationIconPlacement: "title",
      showDek: false,
      upperMetaSecondComponent: null,
    },
    searchPage: {
      imagePosition: "right",
      lowerMetaFirstComponent: "ContentBlockByline",
      upperMetaFirstComponent: "Category",
      upperMetaSecondComponent: "Timestamp",
    },
    searchPageWithoutCategory: {
      imagePosition: "right",
      lowerMetaFirstComponent: "ContentBlockByline",
      upperMetaFirstComponent: "Timestamp",
      upperMetaSecondComponent: null,
    },
    fiveGridPattern: {
      contentBlockSize: "micro",
      imagePosition: "right",
      lowerMetaFirstComponent: null,
      showDek: false,
      upperMetaSecondComponent: null,
    },
    fiveGridPackagePattern: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "right",
      lowerMetaFirstComponent: "ContentBlockAdvertiserFlag",
      showDek: false,
      upperMetaFirstComponent: "Category",
      upperMetaSecondComponent: null,
    },
    fiveGridGameGuidesPattern: {
      contentBlockSize: "small",
      imagePosition: "right",
      lowerMetaFirstComponent: null,
      showDek: false,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
    },
    podcastSection: {
      contentBlockSize: "small",
      imageAspectRatio: "square",
      imagePosition: "left",
      lowerMetaFirstComponent: null,
      showDek: true,
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
    },
    threeGridPattern: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "right",
      lowerMetaFirstComponent: null,
      showDek: false,
      upperMetaSecondComponent: null,
    },
    threeGridAltPattern: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "left",
      lowerMetaFirstComponent: null,
      showDek: false,
      upperMetaSecondComponent: null,
    },
    threeUpWithCategories: {
      contentBlockSize: "micro",
      latestRecircPadding: true,
      upperMetaSecondComponent: null,
      upperMetaFirstComponent: null,
    },
    threeUpWithCategoriesMobile: {
      contentBlockSize: "small",
      latestRecircPadding: true,
      upperMetaSecondComponent: null,
      upperMetaFirstComponent: null,
    },
    sevenUpPattern: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "hideImage",
      lowerMetaSecondComponent: null,
      upperMetaSecondComponent: null,
      showDek: false,
    },
    eightUpPattern: {
      contentBlockSize: "small",
      contentBlockVariation: "special",
      imagePosition: "hideImage",
      upperMetaFirstComponent: "Timestamp",
      upperMetaSecondComponent: null,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: false,
    },
    guidesSection: {
      contentBlockSize: "micro",
      contentBlockVariation: "standard",
      imagePosition: "right",
      imageAspectRatio: "square",
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      lowerMetaThirdComponent: null,
      showDek: false,
      upperMetaSecondComponent: null,
      upperMetaFirstComponent: null,
    },
    videoSection: {
      contentBlockSize: "medium",
      contentBlockVariation: "standard",
      imagePosition: "right",
      imageAspectRatio: "wide",
      lowerMetaFirstComponent: null,
      showDek: false,
      upperMetaSecondComponent: null,
    },
    mapSection: {
      contentBlockSize: "small",
      contentBlockVariation: "standard",
      upperMetaFirstComponent: null,
      upperMetaSecondComponent: null,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: false,
      imagePosition: "left",
    },
    mapSectionFeatured: {
      contentBlockSize: "medium",
      contentBlockVariation: "standard",
      imagePosition: "hideImage",
      upperMetaFirstComponent: "Category",
      upperMetaSecondComponent: null,
      upperMetaThirdComponent: null,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: false,
    },
    mapSearchFeatured: {
      contentBlockSize: "medium",
      contentBlockVariation: "standard",
      imagePosition: "hideImage",
      upperMetaFirstComponent: "Category",
      upperMetaSecondComponent: null,
      upperMetaThirdComponent: null,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: false,
    },
    elevatedGridPattern: {
      contentBlockSize: "large",
      contentBlockVariation: "standard",
      imagePosition: "hideImage",
      upperMetaSecondComponent: null,
      upperMetaThirdComponent: null,
      lowerMetaFirstComponent: null,
      lowerMetaSecondComponent: null,
      showDek: false,
    },
  },
};

export default compactContentCardConfig;
